import { useQuery } from '@tanstack/react-query';
import { auditApi } from '@/api/audit';

export function useAuditLogs(params?: Record<string, any>) {
  return useQuery({
    queryKey: ['audit', params],
    queryFn: () => auditApi.list(params),
  });
}

export function useAuditLog(id: string) {
  return useQuery({
    queryKey: ['audit', id],
    queryFn: () => auditApi.get(id),
    enabled: !!id,
  });
}
